import { CONSENT_EVENT, hasAnalyticsConsent } from "@/lib/consent";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let analyticsReady = false;

function getAnalyticsId(): string | null {
  const raw = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (typeof raw !== "string") return null;
  const value = raw.trim();
  return value.length > 0 ? value : null;
}

function injectAnalyticsScript(measurementId: string): void {
  if (document.getElementById("ga-script")) return;
  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
}

function bootAnalytics(measurementId: string): void {
  if (analyticsReady) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    anonymize_ip: true,
    transport_type: "beacon",
  });
  analyticsReady = true;
}

export function initAnalytics(): void {
  const measurementId = getAnalyticsId();
  if (!measurementId) return;

  const tryEnable = () => {
    if (!hasAnalyticsConsent()) return;
    injectAnalyticsScript(measurementId);
    bootAnalytics(measurementId);
  };

  tryEnable();
  window.addEventListener(CONSENT_EVENT, tryEnable);
}

export function trackEvent(eventName: string, params: Record<string, unknown> = {}): void {
  if (!analyticsReady || typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
}

export function trackPageView(path: string): void {
  const measurementId = getAnalyticsId();
  if (!analyticsReady || !measurementId || typeof window.gtag !== "function") return;
  window.gtag("config", measurementId, {
    page_path: path,
  });
}
